module.exports = __webpack_public_path__ + "static/media/close-circle.4f70d054.png";